import { useAppSelector } from "@/shared/lib/redux"
import { ChartBlock } from "@/shared/ui/chart-block"
import { useMemo } from "react"
import { selectChannels, selectMarketingCampaignStatistics } from "@/entities/marketing-campaign"

export const ReferrerDonutChart = () => {
    const statistics = useAppSelector(selectMarketingCampaignStatistics)
    const channels = useAppSelector(selectChannels)
    const data = useMemo(() => {
        return {
            labels: statistics.map((statistics) => channels.find((channel) => channel.telegramId === statistics.channelId)?.name || "Неизвестный источник"),
            datasets: [{
                
                data: statistics.map((statistics) => statistics.transitions)
            }]
        }
            
    }, [statistics, channels])

    return (
        <ChartBlock 
            chartClass="min-h-[284px] h-[1px]"
            type="doughnut" 
            title="Количество переходов" 
            data={data}
            noData={!Boolean(statistics.length)}
            noDataComponent={
                <div className="flex h-full items-center justify-center">
                    <div className="text-xl screen:text-2xl mb-10 font-mediumttf text-white bg-color-secondary rounded-2xl p-4 text-center">
                        НЕДОСТАТОЧНО ДАННЫХ <br />
                        ДЛЯ ФОРМИРОВАНИЯ <br />
                        СТАТИСТИКИ
                    </div>
                </div>
            }    
        />
    )
}